import type { RouteRecordRaw } from "vue-router";
import { createRouter, createWebHistory } from "vue-router";
import type { RouteRecordCustom } from "./RouteInterface";

import FooterComponent from "@/components/Layout/FooterComponent.vue";
import HeaderComponent from "@/components/Layout/HeaderComponent.vue";
import Leftbox from "@/components/Layout/Leftbox.vue";
import Rightbox from "@/components/Layout/Rightbox.vue";
import PhaserGame from "@/components/PhaserGame.vue";
import TileDetailView from "@/views/TileDetail/TileDetailView.vue";

import { RouteNames } from "@/types/ui";
import InfoView from "@/views/Info/InfoView.vue";
import QuestsView from "@/views/Quests/QuestsView.vue";
import SettingsView from "@/views/Settings/SettingsView.vue";
import ShopView from "@/views/ShopView.vue";
import StoryView from "@/views/Story/StoryView.vue";
import UpgradesView from "@/views/UpgradesView.vue";

const routes: RouteRecordCustom[] = [
	{
		path: "/",
		name: RouteNames.LAYOUT_VIEW,
		children: [
			{
				path: "/tile/:x(\\d+)/:y(\\d+)/:isSettlement?",
				name: RouteNames.TILE,
				component: TileDetailView,
			},
			{
				path: "/quests/:tab?/:showPopup?/:questPopupId?",
				name: RouteNames.QUESTS,
				component: QuestsView,
			},
			{
				path: "/upgrades",
				name: RouteNames.UPGRADES,
				component: UpgradesView,
			},
			{
				path: "/shop/:tab?/:scrollTo?",
				name: RouteNames.SHOP,
				component: ShopView,
			},
			{
				path: "/info/:tab?",
				name: RouteNames.INFO,
				component: InfoView,
			},
			{
				path: "/settings",
				name: RouteNames.SETTINGS,
				component: SettingsView,
			},
			{
				path: "/story/:chapter/:id",
				name: RouteNames.STORY,
				component: StoryView,
			},
		],
		components: {
			default: PhaserGame,
			header: HeaderComponent,
			leftbox: Leftbox,
			rightbox: Rightbox,
			footer: FooterComponent,
		},
	},
	// fallback for undefined paths
	{
		// catches all unmatched paths
		path: "/:catchAll(.*)",
		redirect: "/",
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes: routes as RouteRecordRaw[],
});

export default router;
